module.exports = __webpack_public_path__ + "img/3ea6beec64369c2642b92.ef7dce74.png";